import { useTranslation } from "react-i18next";

import { LoadingCard } from "../../../../../../../../_metronic/elements/Loading";
import { useViewAmbientContext } from "../AmbientsContext";
import { useIsMobile } from "../../../../../../../shared/responsive";
import {isPlanetHdJobPending} from "../planetHdJobModel";

const CreatingAmbient = () => {
  const { ambientData, ambientHdData, imageAmbientData, imageAmbientHdData } = useViewAmbientContext();
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const processingItems = [
    ambientData?.status === 0 && {key: "historical", data: ambientData, type: "standard"},
    isPlanetHdJobPending(ambientHdData?.status) && {key: "historical-hd", data: ambientHdData, type: "hd"},
    imageAmbientData?.status === 0 && {key: "image", data: imageAmbientData, type: "image"},
    isPlanetHdJobPending(imageAmbientHdData?.status) && {key: "image-hd", data: imageAmbientHdData, type: "image"},
  ].filter(Boolean).map((item) => ({
    ...item,
    progress: item.data?.progress ? parseInt(item.data.progress * 100, 10) : 0,
  }));

  const copyFor = ({type, progress}) => {
    const prefix = type === "image" ? "image_" : type === "hd" ? "hd_" : "";
    return {
      title: progress < 1
        ? t(`ambient:create.messages.${prefix}in_queue`)
        : t(`ambient:create.messages.${prefix}creating`),
      description: t(`ambient:create.messages.${prefix}request_description`),
      status: progress < 1
        ? t("ambient:create.messages.waiting_processing")
        : t("ambient:create.messages.progress_completed", {progress}),
    };
  };

  if (!isMobile) {
    return (
      <>
        {processingItems.map((item) => {
          const copy = copyFor(item);
          return <LoadingCard key={item.key} loadingText={item.progress < 1 ? copy.title : `${copy.title} ${item.progress}%`} />;
        })}
      </>
    );
  }

  return (
    <div className="view-land-mobile-state-stack">
      {processingItems.map((item) => {
        const copy = copyFor(item);
        return (
          <div className="view-land-mobile-state-card" key={item.key}>
            <div className="view-land-mobile-state-card__header">
              <span className="view-land-mobile-state-card__icon">
                <span className="spinner-border spinner-border-sm" />
              </span>
              <div className="view-land-mobile-state-card__copy">
                <span className="view-land-mobile-state-card__title fs-7">{copy.title}</span>
                <span className="view-land-mobile-state-card__description fs-7">{copy.description}</span>
                <span className="view-land-mobile-state-card__status fs-7">{copy.status}</span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CreatingAmbient;
